import React from 'react'
import { Input, Select, Checkbox } from 'loyal-react'
import PropTypes from 'prop-types'
import yn from 'yn'

const FormMileage = ({
  partners,
  points,
  miles,
  selectPartnersOnChange,
  inputPointsOnblur,
  pointsConverterOnblur,
  inputPointsOnChange,
  errorField,
  isLoadingChangeAccountType,
  inputLoyaltNumberOnChange,
  handleConvertAllPoints,
  convertAllPoints,
  disabledFields,
  handleFormatValue,
  currencyConfiguration,
  fidelityLabel,
  loyaltyNumber,
  validateCPF,
  disableLoyaltyNumber,
  disabledSelectPartners,
  partnerName,
  disableOnFocus,
  disableOnBlur
}) => (
  <div className='row'>
    <div className='col-12 px-0'>
      <div className='row'>
        <Select
          id='MileageType'
          label='Transferir para'
          className='col-12 col-md-6'
          displayValue='name'
          selectedValue='vendorId'
          image='logoUrl'
          options={partners || []}
          onChange={selectPartnersOnChange}
          data-error='Tipo de programa de milhagem invalido'
          valid={errorField}
          disabled={disabledSelectPartners}
        />
        <Input
          id='numero_fidelidade'
          label={fidelityLabel || 'CPF ou Loyalty Number'}
          className='col-12 col-md-6 mt-2 mt-md-0'
          onChange={inputLoyaltNumberOnChange}
          value={loyaltyNumber}
          disabled={disableLoyaltyNumber}
          maxLength='11'
          onBlur={validateCPF}
        />
        {yn(process.env.REACT_APP_MESSAGE_MILEAGE_SMILES) && partnerName === 'Smiles' ? (
          <div className='col-12'>
            <p className='txt-body-sm color-brand-1'>
              Você precisa ter pelo menos 10.000 pontos no {process.env.REACT_APP_TITLE} para conseguir.
            </p>
          </div>
        ) : ('')}
        <div className='col-12 pt-2'>
          <p className='txt-body-sm'>
            Quantos {currencyConfiguration.pointsName} deseja transferir?
          </p>
        </div>
        <Input
          id='pontos_converter'
          label={`Quantidade de ${currencyConfiguration.pointsName}`}
          className='col-12 col-md-6 mt-2'
          value={points}
          onChange={inputPointsOnChange}
          onFocus={disableOnFocus}
          onBlur={disableOnBlur}
          disabled={disabledFields || convertAllPoints}
          maxLength='7'
        />
        <Input
          id='milhas_obter'
          label='Você vai receber no programa parceiro'
          className='col-12 col-md-6 mt-2 price-value d-none'
          value={handleFormatValue(miles || 0)}
          disabled={disabledFields}
        />
        <div className='col-12 col-md-6 pt-1'>
          <div className='row mx-0 align-items-center h-100 pt-half'>
            <Checkbox
              style={{ position: 'relative', marginLeft: '20px' }}
              id='converter_todos_pontos'
              className='col-12 checkbox-field'
              labelClass='l-1'
              label={`Transferir todos os meus ${currencyConfiguration.pointsName}.`}
              checked={convertAllPoints}
              onChange={handleConvertAllPoints}
              disabled={disabledFields}
            />
          </div>
        </div>
      </div>
      <br />
      <div
        className={`btn-loading mr-auto ml-auto ${
          isLoadingChangeAccountType ? 'd-block' : 'd-none'
        }`}
      >
        <div />
        <div />
        <div />
        <div />
      </div>
    </div>
  </div>
)

FormMileage.propTypes = {
  partners: PropTypes.array,
  partnerName: PropTypes.string,
  points: PropTypes.number,
  miles: PropTypes.number,
  selectPartnersOnChange: PropTypes.func,
  inputPointsOnblur: PropTypes.func,
  pointsConverterOnblur: PropTypes.func,
  inputPointsOnChange: PropTypes.func,
  errorField: PropTypes.bool,
  isLoadingChangeAccountType: PropTypes.bool,
  inputLoyaltNumberOnChange: PropTypes.func,
  handleConvertAllPoints: PropTypes.func,
  convertAllPoints: PropTypes.bool,
  disabledFields: PropTypes.bool,
  handleFormatValue: PropTypes.func,
  currencyConfiguration: PropTypes.object,
  fidelityLabel: PropTypes.string,
  loyaltyNumber: PropTypes.number,
  validateCPF: PropTypes.func,
  disableOnFocus: PropTypes.func,
  disableOnBlur: PropTypes.func,
  disableLoyaltyNumber: PropTypes.bool,
  disabledSelectPartners: PropTypes.bool
}

export default FormMileage



// WEBPACK FOOTER //
// ./src/features/MileageRescue/FormMileage.js